/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/**
 * The base breakpoints for the Material Dashboard 2 React.
 * You can add new breakpoints using this file.
 * You can customized the breakpoints for the entire Material Dashboard 2 React using thie file.
 */

// Must stay byte-identical to assets/theme/base/breakpoints.js — the sidenav styles read
// `navOverlay`/`navFull` from whichever theme is active, and a key missing here would emit an
// invalid media query in dark mode. (`laptop` was already missing; added for the same reason.)
const breakpoints = {
  values: {
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    navOverlay: 1024,
    xl: 1200,
    xxl: 1400,
    navFull: 1440,
    laptop: 1600,
  },
};

export default breakpoints;
